
import phoneCardStyle from '../cards/phoneCardStyle.module.css'


const CopyRight = () => {

  return (
    <div
      className={phoneCardStyle.cardContainer}
      key={"000000"}
      id={"firstCard"}
      title={"برمجة وتصميم عبد الكريم الحلبي"}
    >
      <div className={phoneCardStyle.title}>
        <h4 className={phoneCardStyle.rotatedTitle}>حقوق البرمجة والتصميم</h4>
      </div>
      <article className={phoneCardStyle.card1}>
        <div className={phoneCardStyle.cardCollegeHeader}>
          <span className={phoneCardStyle.collegeAvatar}>
            <h3 className={phoneCardStyle.department}>
              الجامعة الوطنية الخاصة
            </h3>
          </span>
          <div className={phoneCardStyle.collegeName}>
            حقوق البرمجة والتصميم
          </div>
        </div>
        <table style={{textAlign:"center",fontSize:"8px"}}>
          <thead>
            <tr>   
              <td colSpan={'3'}>____________________________</td>
            </tr>
          </thead>
          <tbody>
          <tr>
              <td>البرمجة والتصميم</td>
              <td colSpan={'2'}>عبدالكريم الحلبي</td>
            </tr>
            <tr>
              <td>بالتعاون مع</td>
              <td colSpan={'2'}><h1>فريق تقنية المعلومات </h1></td>
            </tr>
            <tr>
              <td>هاتف</td>
              <td colSpan={'2'}>963-991-566-246+</td>
            </tr>
            <tr>
              <td>بريد الكتروني</td>
              <td colSpan={'2'} className={phoneCardStyle.email}>karim@consultant.com</td>
            </tr>
            {/* <tr>
              <td colSpan={'3'} style={{display:'grid',placeContent:'center',width:'50%'}}>
                <img src={ITCLogo} alt={'Logo'} title={"CopyRight"} height={250}  style={{display:'grid',placeContent:'center',borderRadius:'50%'}}/>
              </td>           
            </tr> */}
          </tbody>
        </table>
      </article>
    </div>
  );
};
export default CopyRight;
